import './polyfill';

/* NAVBAR */
const navs = document.querySelectorAll('.m-nav-item-label');

Array.prototype.forEach.call(navs, n => {
  const href = n.getAttribute('href');
  if (!href) return;
  if (href.split('/')[1] === window.location.href.split('/').pop()) {
    n.classList.add('m-nav-item-label-active');
  }
});
